/**
 * Versão semântica do produto. Atualizar a cada release major.
 *
 * Convenção: o "v3" técnico (repo `eurostorm_gestion_v3`) vira versão major 3.
 * Próximas releases dentro da branch atual: 3.1.0, 3.2.0... Reescrita
 * arquitetural significativa → 4.0.0.
 */
export const APP_VERSION = "3.0.0";
